import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './header.css';

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,  
  NavItem,  
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from 'reactstrap';

import logo from "../../assets/images/logoNb.png";
import Auth from '../../services/AuthService';
import decode from "jwt-decode";
import UrlHelper from '../../Helpers/urlHelper';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';



window.addEventListener("scroll", function () {
  if (window.scrollY < 16 && window.screen.width > 766) {
    document.getElementById("menuBar").style.cssText = "background: transparent"
  } else  {
    document.getElementById("menuBar").style.cssText = "background: #24272c; top: 0";
  } 
});

function Header(props) {
  const [ , setUsername] = useState('');
  const [checked, setChecked] = useState(true);
  const urlProfile = UrlHelper.buildProfileUrl();

  const [isOpen, setIsOpen] = useState(false);
  const isLogged = Auth.isAuthenticated();
  if (isLogged && isOpen && checked) {

    const user = decode(Auth.getData().data.id_token);
    setUsername(user.given_name);
    setChecked(false);
  }
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar id="menuBar" expand="md" fixed="top" className="transition-slow">
      <NavbarBrand className="navbar-brand">
        <Link to="/">
          <img src={logo} className="logoTopo" alt="logo" />
        </Link>
      </NavbarBrand>
      <NavbarToggler onClick={toggle}>
        <FontAwesomeIcon icon={faBars} className="text-light" size="lg" />
      </NavbarToggler>
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ml-auto" navbar>
          <NavItem>
            <Link className="anchor nav-link" to="/home" onClick={toggle}> Início</Link>
          </NavItem>
          <NavItem>
            <Link className="anchor nav-link" to="/infoUser" onClick={toggle}> Informações</Link>
          </NavItem>
          <NavItem>
            <Link className="anchor nav-link" to="/enem" onClick={toggle}> ENEM</Link>
          </NavItem>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle className="anchor" nav caret>
              Competências
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem className="p-0 lit-dropdown">
                <Link className="nav-link" to="/linguagens" onClick={toggle}> LIT</Link>
              </DropdownItem>
              <DropdownItem className="p-0 mtt-dropdown">
                <Link className="nav-link" to="/matematica" onClick={toggle}> MTT</Link>
              </DropdownItem>
              <DropdownItem className="p-0 cnt-dropdown">
                <Link className="nav-link" to="/ciencias" onClick={toggle}> CNT</Link>
              </DropdownItem>
              <DropdownItem className="p-0 chsa-dropdown">
                <Link className="nav-link" to="/ciencias-humanas-e-sociais" onClick={toggle}> CHSA</Link>
              </DropdownItem>
              <DropdownItem className="p-0 ftp-dropdown">
                <Link className="nav-link" to="/formacao-tecnica-profissional" onClick={toggle}> FTP</Link>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          {props.username !== null ?
            <UncontrolledDropdown className="userName" nav inNavbar>
            <DropdownToggle className="anchor" nav caret>
              {props.username}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem className="p-0">
                <Link to={urlProfile}>Minha conta</Link>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown> : null
        }
        </Nav>
        {!isLogged ?
          <Link className='anchor' to={UrlHelper.buildLoginUrl()}>
            <Button color="primary" size="md" className="btn-login">
              <FontAwesomeIcon icon={faUserCircle} size="lg" className="mr-2" /> Login
            </Button>
          </Link> : null
        }
        {
          isLogged ?
          <Link className='anchor' to={UrlHelper.buildLogoutUrl()}>
            <Button color="danger" size="md" className="btn-login mt-2 mb-3">
              <FontAwesomeIcon icon={faSignOutAlt} size="lg" className="mr-2" /> Sair
            </Button>
          </Link>: null
        }
      </Collapse>
    </Navbar>
  );
}

export default Header;
